/* Variant-dependent WAKO icon, restricted by Liquid to the six Lorica G4 products. */
(() => {
  if (customElements.get('trj-g4-variant-badge')) return;

  customElements.define('trj-g4-variant-badge', class extends HTMLElement {
    connectedCallback() {
      const productInfo = this.closest('product-info');
      if (!productInfo || typeof window.subscribe !== 'function') return;

      this.unsubscribe = window.subscribe(window.theme.PUB_SUB_EVENTS.variantChange, ({ data }) => {
        const sectionId = productInfo.dataset.originalSection || productInfo.dataset.section;
        if (String(data.sectionId) !== String(sectionId)) return;
        this.hidden = String(data.variant?.id) !== this.dataset.wakoVariantId;
      });
    }

    disconnectedCallback() {
      this.unsubscribe?.();
      this.unsubscribe = null;
    }
  });
})();
